const getEnvFromUrl = (env: string[], location: string) => {
  return env.some(str => location.indexOf(str) > -1);
};
export default getEnvFromUrl;
